import { TravelOptionTab, TravelTypes } from '../constants';

const convertTravelTypeToTravelOptionTab = (travelType) => {
  if (travelType === TravelTypes.cruise) {
    return TravelOptionTab.CRUISE;
  } if (travelType === TravelTypes.hotel) {
    return TravelOptionTab.HOTEL;
  } if (travelType === TravelTypes.flight) {
    return TravelOptionTab.FLIGHT;
  } if (travelType === TravelTypes.carrental) {
    return TravelOptionTab.GROUND;
  } if (travelType === TravelTypes.custom) {
    return TravelOptionTab.CUSTOM;
  } if (travelType === TravelTypes.tour) {
    return TravelOptionTab.TOUR;
  }
  return null;
};

export default convertTravelTypeToTravelOptionTab;
